import { render } from "./SectionTransactionHistory.vue?vue&type=template&id=408846ea&scoped=true"
import script from "./SectionTransactionHistory.vue?vue&type=script&lang=js"
export * from "./SectionTransactionHistory.vue?vue&type=script&lang=js"

import "./SectionTransactionHistory.vue?vue&type=style&index=0&id=408846ea&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408846ea"]])

export default __exports__